/**
 * A WordPress attachment as the importer resolved it: the ACF fields hold IDs,
 * and those were swapped for the file (copied under /public/media) and its
 * metadata. Width and height are missing for video.
 */
export type Media = {
  src: string;
  mime: string;
  alt: string;
  width?: number;
  height?: number;
};

/**
 * ACF stores an empty image or file field as false rather than null.
 */
export type MaybeMedia = Media | false | null | undefined;

export function isVideo(media: MaybeMedia): media is Media {
  return !!media && media.mime.startsWith("video/");
}

export function isSvg(media: MaybeMedia): boolean {
  return !!media && media.mime === "image/svg+xml";
}

/**
 * Path to a file shipped with the theme (logos, icons, theme videos), copied
 * under /public/theme/images.
 */
export function themeImage(path: string) {
  return `/theme/images/${path}`;
}
